// Centralized Chakra theme with semantic tokens for light (pastel) and dark modes
import { extendTheme } from '@chakra-ui/react';

const config = {
  initialColorMode: 'system',
  useSystemColorMode: true,
};

const colors = {
  brand: {
    50: '#f7f2ff',
    100: '#eee4ff',
    200: '#dcc8ff',
    300: '#c1a6ff',
    400: '#a47ff6',
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95',
  },
  paper: {
    50: '#fdf7ef',  // canvas
    100: '#f6eddf', // header + cards
    150: '#efe3d0',
    200: '#e4d6c3', // borders / elevated
  },
};

const semanticTokens = {
  colors: {
    // Page + app chrome
    'bg.canvas': { default: 'paper.50', _dark: '#111111' },
    'bg.surface': { default: 'paper.100', _dark: '#111111' },
    'bg.subtle': { default: 'paper.50', _dark: '#111111' },
    'bg.elevated': { default: 'paper.200', _dark: '#111111' },
    'bg.header': { default: 'paper.150', _dark: '#111111' },

    // Borders
    'border.subtle': { default: '#d5c8b5', _dark: 'whiteAlpha.200' },

    // Text
    'text.primary': { default: '#2b2620', _dark: 'whiteAlpha.900' },
    'text.muted': { default: '#6b5f52', _dark: 'gray.400' },
    'text.subtle': { default: '#847768', _dark: 'gray.500' },

    // Accents (buttons, pills, etc.)
    'accent.solidBg': { default: 'brand.300', _dark: 'brand.300' },
    'accent.solidText': { default: 'white', _dark: 'gray.900' },
    'accent.subtleBg': { default: 'brand.100', _dark: 'whiteAlpha.100' },
    'accent.subtleText': { default: 'brand.700', _dark: 'brand.200' },

    // Status colors for schedule/chat badges
    'status.successBg': { default: '#e8f5e9', _dark: '#111111' },
    'status.todoBg': { default: '#f5f0e6', _dark: '#111111' },
  },
};

const styles = {
  global: {
    'html, body, #root': {
      height: '100%',
    },
    body: {
      bg: 'bg.canvas',
      color: 'text.primary',
      letterSpacing: '0.01em',
      backgroundImage: 'none',
      margin: 0,
      padding: 0,
    },
  },
};

const components = {
  Card: {
    baseStyle: (props) => ({
      bg: 'bg.surface',
      borderRadius: 'xl',
      borderWidth: '1px',
      borderColor: 'border.subtle',
      boxShadow: props.colorMode === 'light' ? '0 8px 24px rgba(31,24,13,0.08)' : 'none',
    }),
  },
  Box: {
    variants: {
      surface: (props) => ({
        bg: 'bg.surface',
        borderRadius: 'xl',
        borderWidth: '1px',
        borderColor: 'border.subtle',
        boxShadow: props.colorMode === 'light' ? '0 8px 24px rgba(31,24,13,0.08)' : 'none',
      }),
    },
  },
  Button: {
    baseStyle: {
      borderRadius: 'full',
    },
  },
};

const theme = extendTheme({
  config,
  colors,
  semanticTokens,
  styles,
  components,
});

export default theme;
